import React, { useEffect, useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const useIsomorphicLayoutEffect =
  typeof window !== "undefined" ? useLayoutEffect : useEffect;

/**
 * Scrollable main area for dashboard layouts. The layout (and this container)
 * stays mounted across route changes, so its scroll position would otherwise
 * leak from one page to the next — reset it on every navigation.
 */
const DashboardScrollArea = ({ children, className = "min-h-0 flex-1 overflow-y-auto" }) => {
  const ref = useRef(null);
  const { pathname, search, hash } = useLocation();

  useIsomorphicLayoutEffect(() => {
    if (ref.current) {
      ref.current.scrollTop = 0;
      ref.current.scrollLeft = 0;
    }
  }, [pathname, search, hash]);

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
};

export default DashboardScrollArea;
